export const SET_RELATIONS = 'setRelations';
export const SET_RELATION = 'setRelation';
export const SET_ERROR = 'setRelationsError';
